// lex.ivoliq — gängige österreichische Titel (Aug 2026).
// Vorgestellte Titel erscheinen in der Anrede, nachgestellte nur auf der Honorarnote.
export const SALUTATIONS = ["Herr", "Frau"];

export const TITLE_PREFIXES = [
  "Mag.", "Dr.", "Mag. Dr.", "MMag.", "DDr.",
  "Priv.-Doz. Dr.", "Prof. Dr.", "Univ.-Prof. Dr.",
];

export const TITLE_SUFFIXES = [
  "LL.M.", "LL.B.", "MBA", "M.B.L.", "MBL",
  "MSc", "MA", "PhD", "DPhil",
];
